
import React from "react";
import { Box, Typography, Paper, Stack, Divider } from "@mui/material";
import {useTranslation} from "react-i18next";
import {CART_NOTIFICATION} from "../../../locales/components/namespaces";

export default function OrderItemsSection({ orderItems, orderTotals }) {
    const {t} = useTranslation(CART_NOTIFICATION);
    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                    fontWeight: 900,
                    fontSize: { xs: 28, md: 36 },
                    lineHeight: "110%",
                    textTransform: "uppercase",
                    color: "#111111",
                    mb: 2,
                }}
            >
                {t("My order")}
            </Typography>
            <Stack spacing={0.5} sx={{ mb: 2 }}>
                {orderItems.map((item) => (
                    <Paper
                        key={item.id}
                        sx={{
                            p: 1.5,
                            borderRadius: "10px",
                            backgroundColor: "#E9E9E9",
                            display: "flex",
                            alignItems: "center",
                            gap: 2.5,
                        }}
                    >
                        <Box
                            sx={{
                                width: 82,
                                height: 72,
                                borderRadius: "5px",
                                backgroundColor: "#D9D9D9",
                                backgroundImage: `url(${item.imageUrl})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                flexShrink: 0,
                            }}
                        />
                        <Box
                            sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.3,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontWeight: 700,
                                    fontSize: 16,
                                    lineHeight: "120%",
                                    color: "#E5007E",
                                }}
                            >
                                {item.quantityLabel}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontWeight: 700,
                                    fontSize: 14,
                                    lineHeight: "90%",
                                    textTransform: "uppercase",
                                    color: "#111111",
                                }}
                            >
                                {item.sku}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontSize: 14,
                                    lineHeight: "120%",
                                    color: "#111111",
                                }}
                            >
                                {item.name}
                            </Typography>
                        </Box>
                        {/* price */}
                        <Typography
                            sx={{
                                fontFamily: "'Zen Maru Gothic', sans-serif",
                                fontWeight: 700,
                                fontSize: 16,
                                lineHeight: "120%",
                                color: "#111111",
                                minWidth: 80,
                                textAlign: "right",
                            }}
                        >
                            {item.price}
                        </Typography>
                    </Paper>
                ))}
            </Stack>

            {/* Totals box */}
            <Paper
                sx={{
                    mt: 1,
                    borderRadius: "10px",
                    backgroundColor: "#E9E9E9",
                    px: { xs: 2, md: 3 },
                    py: { xs: 2, md: 2.5 },
                    display: "flex",
                    justifyContent: { xs: "center", md: "flex-end" },
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: 375,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                    }}
                >
                    {orderTotals.map((row, index) => (
                        <Box key={row.key}>
                            {/*{index > 0 && !row.isGrandTotal && (*/}
                            {/*    <Divider sx={{ mb: 1 }} />*/}
                            {/*)}*/}

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: row.isGrandTotal ? "center" : "flex-end",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: "'Zen Maru Gothic', sans-serif",
                                        fontSize: row.isGrandTotal ? 20 : 16,
                                        fontWeight: row.isGrandTotal ? 700 : 400,
                                        lineHeight: "120%",
                                        color: "#111111",
                                    }}
                                >
                                    {row.label}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontFamily: "'Zen Maru Gothic', sans-serif",
                                        fontSize: row.isGrandTotal ? 20 : 16,
                                        fontWeight: row.isGrandTotal ? 700 : 400,
                                        lineHeight: "120%",
                                        textAlign: "right",
                                        color: "#111111",
                                    }}
                                >
                                    {row.value}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Paper>
        </Box>
    );
}
